import { render } from "./languageText.vue?vue&type=template&id=ad8a3d2c"
import script from "./languageText.vue?vue&type=script&lang=js"
export * from "./languageText.vue?vue&type=script&lang=js"

import "./languageText.vue?vue&type=style&index=0&id=ad8a3d2c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__